import PropTypes from 'prop-types'
import { ThCell } from './ThCell'

export const TableHead = ({
  schema,
  isStickyFirstCol,
  sort,
  changeSort,
  isNoStickyHead,
}) => {
  return (
    <tr>
      {schema.map((col, colIndex) => {
        return (
          <ThCell
            key={colIndex}
            col={col}
            sticky={isStickyFirstCol && colIndex === 0}
            sort={sort}
            changeSort={changeSort}
            isNoStickyHead={isNoStickyHead}
          />
        )
      })}
    </tr>
  )
}

TableHead.propTypes = {
  schema: PropTypes.array.isRequired,
  isStickyFirstCol: PropTypes.bool,
  sort: PropTypes.shape({
    sortBy: PropTypes.string,
    sortDirection: PropTypes.string,
  }),
  changeSort: PropTypes.func,
}

TableHead.defaultProps = {
  isStickyFirstCol: false,
}
